import React from 'react'
import './card.css';

export default function card(props) {
  return (
    <div className='card-container'>
         <div className='card'>
          <img src={`../images/${props.coverImg}`} alt='Greek' className='greek' />
          <div className='greek-container'>
            <h5 className='greek-top'>{props.title}</h5>
            <span className='greek-price'>${props.price}</span>
          </div>
          <p className='greek-text'>
          {props.description}
          </p>
          <div className='greek-order'>{props.actionPoint}</div>

         </div>
      </div>
  )
}
